import { createSlice } from "@reduxjs/toolkit";

const initialMenuState = {
    menuPermission: [],
    redirectRootMenu: ""
};

export const menuSlice = createSlice({
    name: "menu",
    initialState: initialMenuState,
    reducers: {
        setMenuPermission: (state, action) => {
            const { menuPermission } = action.payload;
            state.menuPermission = menuPermission;
        },
        setRedirectRootMenu: (state, action) => {
            const { pathName } = action.payload;
            state.redirectRootMenu = pathName;
        }
    },
});

export const menuReducers = menuSlice.reducer;
export const menuActions = menuSlice.actions;
